import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import LectureApi from "../../../api/lecture.api";
import DelBtn from "../../../component/atoms/button/delBtn";
import EditBtn from "../../../component/atoms/button/editBtn";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import FileImgPreview from "../../../component/molecules/fileImgPreview";
import GoBack from "../../../component/molecules/goBack";
import TableTab02 from "../../../component/molecules/tableTab02";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { route } from "../../../router/route";
import { currentLectureType } from "../../../store/currentCategory";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import StudentModal from "../_component/studentModal";

const LectureCurriculum = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [curriculumInfo, setcurriculumInfo] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const [currentType, setCurrentType] = useRecoilState(currentLectureType);

  const tabList = [
    {
      title: "강의 상세",
      link: `${route.lecture_lecture_info}/${id}`,
      originLink: route.lecture_lecture_info,
    },
    {
      title: "커리큘럼",
      link: `${route.lecture_lecture_curriculum}/${id}`,
      originLink: route.lecture_lecture_curriculum,
    },
    {
      title: "수강후기 관리",
      link: `${route.lecture_lecture_review}/${id}`,
      originLink: route.lecture_lecture_review,
    },
  ];

  useEffect(() => {
    getLectureInfo();
    getLectureType();
  }, []);

  const getLectureType = async () => {
    try {
      const response = (await LectureApi.getLectureById(id)).data.data.content;
      setCurrentType(response.lectureCategoryType);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getLectureInfo = async () => {
    try {
      const data = {
        lectureVideoId: id,
        orderBy: "ASC",
        size: 0,
      };

      const response = (await LectureApi.getCurriculum(data)).data.data.content;
      setcurriculumInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: [id],
      };
      await LectureApi.delLecture(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  const [lectureList, setLectureList] = useState([]);

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const [selectedData, setSelectedData] = useState({});
  const [detailModalOpen, setDetailModalOpen] = useState(false);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack
              onClick={() => {
                if (currentType === "FINANCE_STUDY") {
                  navigate(route.lecture_lecture_finance);
                } else {
                  navigate(route.lecture_lecture_paid);
                }
              }}
            />
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <DelBtn onClick={() => setDeleteModalOpen(true)} />
              <EditBtn
                onClick={() => {
                  navigate(route.lecture_lecture_curriculum_edit + `/${id}`);
                }}
              />
            </div>
          </DetailTop>
          <TableTab02 list={tabList} style={{ marginBottom: "20px" }} />
          {curriculumInfo?.map((item, index) => {
            return (
              <DetailPage key={index}>
                <DetailPageTitle>커리큘럼 {index + 1}강</DetailPageTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <DetailPageForm>
                    <DetailFormTitle>영상</DetailFormTitle>
                    <FileImgPreview fileName={item.videoOriginFileName} serverFileName={item.videoServerFileName} isVideo={true} />
                  </DetailPageForm>
                  <DetailPageForm>
                    <DetailFormTitle>제목</DetailFormTitle>
                    <DetailFormText>{item.title}</DetailFormText>
                  </DetailPageForm>
                  <DetailPageForm>
                    <DetailFormTitle>설명</DetailFormTitle>
                    <DetailFormText>{item.content}</DetailFormText>
                  </DetailPageForm>
                </div>
              </DetailPage>
            );
          })}
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}

      {detailModalOpen ? <StudentModal data={selectedData} setModalOpen={setDetailModalOpen} /> : ""}
    </>
  );
};

export default LectureCurriculum;
